module.exports = __webpack_public_path__ + "static/img/sence2.e92a805.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/media5/sence2.png
// module id = xmfr
// module chunks = 7